module.exports = __webpack_public_path__ + "static/media/dots.50f7cc60.svg";